import { randomInt } from 'crypto';
import Styles from './Library.module.scss';

interface LibraryProps {
    data: any;
    activeLink: string;
    onClickOption: (data: string) => void;
}

const Library = ({ data, activeLink, onClickOption }: LibraryProps) => {


    const sampleAC = [
        "https://marketplace.canva.com/EAEdeiU-IeI/1/0/1600w/canva-purple-and-red-orange-tumblr-aesthetic-chill-acoustic-classical-lo-fi-playlist-cover-jGlDSM71rNM.jpg",
        "https://d2rd7etdn93tqb.cloudfront.net/wp-content/uploads/2022/03/spotify-playlist-cover-orange-headphones-032322.jpg",
        "https://i.redd.it/6edffsd31bn31.jpg",
        "https://www.musicinminnesota.com/wp-content/uploads/2022/01/Photo-by-davisuko-on-Unsplash-.jpg",
        "https://wpimg.pixelied.com/blog/wp-content/uploads/2021/06/15134504/Spotify-Cover-Art-with-Text-Aligned-480x480.png",
        "https://d2rd7etdn93tqb.cloudfront.net/wp-content/uploads/2022/03/spotify-playlist-cover-abstract-piano-art-032322.jpg"
    ]

    const min = 0;
    const max = sampleAC.length - 1;


    const getAlbumCoverIndex = () => {
        const rand = Math.ceil(min + Math.random() * (max - min));
        return rand;
    }

    return (
        <div className={Styles.container} style={{ padding: `${activeLink ? "" : "8px 8px"}` }}>
            {
                activeLink
                    ? <iframe className={Styles.frame} src={activeLink} frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
                    :
                    <>
                        <div className={Styles.title}>
                            Playlists
                        </div>
                        {
                            data.map((option: any) => {
                                return (
                                    <div className={Styles.option} key={option.id} onClick={() => { onClickOption(option.link) }} >
                                        <div className={Styles.cover_photo}>
                                            <img src={option.pfp || sampleAC[getAlbumCoverIndex()]} />
                                        </div>
                                        <div className={Styles.label}>
                                            {option.label}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </>
            }
        </div>
    )
}

export default Library
